import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FMDialog from '@material-ui/core/Dialog';
import FMDialogTitle from '@material-ui/core/DialogTitle';
import FMDialogContent from '@material-ui/core/DialogContent';
import FMDialogActions from '@material-ui/core/DialogActions';
import { FMButton } from 'atoms';
import { FMLoading } from 'molecules';
import { FMDropDownTree } from 'organisms';
import { TreeType, TreeDisplayStateType } from 'features/FMTree';
import style from './Dialogs.style';

interface OwnProps {
    title: string;
    import: (data: string, parentId: string) => void;
    cancel: () => void;
    filesAccept: string;
    treeInitialValue?: string;
    isLoading?: boolean;
}

type Props = OwnProps & WithStyles;

interface State {
    data: string;
    fileName: string;
}

class FMImportDialog extends React.Component<Props, State> {

    private treeRef: any;

    constructor(props: Props) {
        super(props);

        this.treeRef = React.createRef();

        this.state = {
            data: '',
            fileName: '',
        };
    }

    private setFileName = event => {
        if (event.target.files.length === 0) {
            return;
        }

        let file = event.target.files[0];
        let reader = new FileReader();
        reader.onload = (readEvent: any) => this.setState({ data: readEvent.target.result, fileName: file.name });
        reader.readAsText(file);
    }

    private importData = () => {
        let parentGroup = this.treeRef.current.getSelection();
        let parentId = parentGroup === null ? '' : parentGroup.id;
        this.props.import(this.state.data, parentId);
    }

    public render() {
        return (
            <FMDialog open={true}>
                <FMDialogTitle>{this.props.title}</FMDialogTitle>
                {
                    this.props.isLoading && <FMLoading />
                }
                {
                    !this.props.isLoading &&
                    <React.Fragment>
                        <FMDialogContent>
                            <div className={this.props.classes.contentLine}>
                                <input
                                    id="file-import-input"
                                    type="file"
                                    accept={this.props.filesAccept}
                                    style={{ display: 'none' }}
                                    onChange={this.setFileName}
                                />
                                <label htmlFor="file-import-input">
                                    <FMButton variant="outlined" component="span">
                                        {fmtools.translate('select_kml')}
                                    </FMButton>
                                </label>
                                <Typography className={this.props.classes.fileName}>{this.state.fileName}</Typography>
                            </div>
                            <div className={this.props.classes.contentLine}>
                                <Typography className={this.props.classes.paramLabel}>
                                    {fmtools.translate('ParentGroup')}:
                                </Typography>
                                <FMDropDownTree
                                    ref={this.treeRef}
                                    treeType={TreeType.geofencesTree}
                                    treeDisplayState={TreeDisplayStateType.dropDownGeofencesTree}
                                    initialValue={this.props.treeInitialValue}
                                />
                            </div>
                        </FMDialogContent>
                        <FMDialogActions>
                            <FMButton
                                variant="outlined"
                                onClick={this.props.cancel}
                            >
                                {fmtools.translate('Close')}
                            </FMButton>
                            <FMButton
                                variant="outlined"
                                color="primary"
                                onClick={this.importData}
                            >
                                {fmtools.translate('Import')}
                            </FMButton>
                        </FMDialogActions>
                    </React.Fragment>
                }
            </FMDialog>
        );
    }

}

export default withStyles(style)(FMImportDialog);
